import { Setting } from './setting.model';
import { GlobalElementType } from '../enums/global-element-type-uid.enum';

export class PageSection {
  type?: GlobalElementType;
  id?: string;  // used for anchor links e.g. <a rel="noopener" target="_blank" href="#{{Id}}"> </a>
  title?: string;
  copy?: string;
  items?: any;
  settings?: Setting[];
  isVisible? = true;
}
